import { getInProductLocale, getInProductLearnLanguage, isInProduct, makePathInProduct } from './inProduct';

const createHistoryWithInProductQueryParam = (history) => {
  if (!isInProduct(history.location)) {
    return history;
  }

  const { push, replace } = history;
  const locale = getInProductLocale(history.location);
  const learnLanguage = getInProductLearnLanguage(history.location);

  const pushWithQueryParam = (path, ...args) => push(
    makePathInProduct(path, locale, learnLanguage),
    ...args,
  );
  const replaceWithQueryParam = (path, ...args) =>
    replace(makePathInProduct(path, locale, learnLanguage), ...args);

  // eslint-disable-next-line no-param-reassign
  history.push = pushWithQueryParam;
  // eslint-disable-next-line no-param-reassign
  history.replace = replaceWithQueryParam;

  return history;
};

export default createHistoryWithInProductQueryParam;
